var map = {
	"./arrow-down-blue.svg": 954,
	"./arrow-down-grey.svg": 955,
	"./arrow-right-white.png": 956,
	"./arrow-right.svg": 957,
	"./blue-loader.svg": 352,
	"./circle-grey.svg": 958,
	"./circle.svg": 959,
	"./coinbaseWalletIcon.svg": 219,
	"./dropdown-blue.svg": 960,
	"./dropdown.svg": 961,
	"./dropup-blue.svg": 962,
	"./ethereum-logo.png": 353,
	"./fortmaticIcon.png": 963,
	"./link.svg": 964,
	"./magnifying-glass.svg": 965,
	"./menu.svg": 966,
	"./metamask.png": 351,
	"./plus-blue.svg": 967,
	"./plus-grey.svg": 968,
	"./portisIcon.png": 969,
	"./question-mark.svg": 970,
	"./question.svg": 971,
	"./spinner.svg": 972,
	"./token-list-logo.png": 973,
	"./token-list/lists-dark.png": 974,
	"./token-list/lists-light.png": 975,
	"./trustWallet.png": 976,
	"./walletConnectIcon.svg": 220,
	"./x.svg": 977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;